
define('known/models/productModel',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/productTypeModel',
	
	//Shims
	'backbone.relational'
], function($, _, Backbone, ProductTypeModel){	
	var Product = Backbone.RelationalModel.extend({	
		defaults: {
			id: null,
			sport: null,
			year: null
	    },
	    
	    relations: [{
	        type: Backbone.HasMany,
	        key: 'productTypes',
	        relatedModel: ProductTypeModel,
	        reverseRelation: {
	            key: 'productSportYearId'
	            //includeInJSON: 'id'
	        }
	    }],
	
	    initialize: function() {
	    	this.set('id', this.get('sport').toUpperCase() + this.get('year'));
	    },
	    
	    parse: function(resp, options) {
			if(resp.sport && resp.year){
				resp.id = resp.sport.toUpperCase() + resp.year;
			}			
		    	
	    	return resp;
	    },
	    
	    activeProducts : function() {
			return this.get("productTypes").filter(function(productType) {
				return productType.get('active');
			}, this);
		},
	    
	    activeUsableProducts : function() {
			return this.get("productTypes").filter(function(productType) {
				var isUsable = false;
				
				//return true if it is active and either purchased or free
				if(productType.get('active')
						&& (productType.get('purchased') || productType.get('price') < .1)){
					isUsable = true;
				}
				return isUsable;
			}, this);
		},
		
		activePurchasedProducts : function() {
			return this.get("productTypes").filter(function(productType) {
				var purchased = false;
				
				//return true if it is active and either purchased or free
				if(productType.get('active')
						&& (productType.get('purchased') && productType.get('price') > 0)){
					purchased = true;
				}
				return purchased;
			}, this);
		},
		
		activePurchasableProducts : function() {
			var maxProd = 0;
			this.maxBought = this.maxBoughtPrice();
			
			var maxProdPriceObj = this.get("productTypes").max(function(productType){
				if(productType.get('active')){
					return productType.get('price');
				} else {
					return 0;
				} 
			}, this);
			
			if(maxProdPriceObj && maxProdPriceObj.get && maxProdPriceObj.get('price') && maxProdPriceObj.get('active')){
				maxProd = maxProdPriceObj.get('price');
			}
			
			//See if there is something to buy
			var purchasableProducts = [];
			if(maxProd > this.maxBought){
				purchasableProducts = this.get("productTypes").filter(function(productType) {
					return productType.get('price') > this.maxBought;
				}, this);
			}
			
			delete this.maxBought;
			return purchasableProducts;
		},
		
		maxBoughtPrice: function() {
			var maxBoughtPrice = 0;
			var boughtProds = this.activePurchasedProducts();
			var maxBoughtPriceObj = _.max(boughtProds, function(productType){ return productType.get('price'); }, this);
			
			if(maxBoughtPriceObj && maxBoughtPriceObj.get && maxBoughtPriceObj.get('price')){
				maxBoughtPrice = maxBoughtPriceObj.get('price');
			}
			
			return maxBoughtPrice;
		},
		
		prettyProdDesc: function(prodId) {
			var prodType = this.get("productTypes").get(prodId);
			var prettyStr = '';
			
			if(prodType){
				prettyStr = this.get('sport')
					+ ' '
					+ this.get('year')
					+ ' '
					+ prodType.prettyProdDesc();
			}
			
			return prettyStr;
	    },
	});
	
	return Product;  
});